import React from 'react';
import moment from 'moment';

const { ReactNativeWebView } = window;

export default class MaintenanceWorkRow extends React.Component {

  renderLabel(status) {
    if(status === "incomplete") {
      return(
        <strong title="status maintenance" className="btn-badge s-incomplete">{status}</strong>
      )
    } else {
      return(
        <strong title="status maintenance" className="btn-badge s-inprogress">{status}</strong>
      )
    }
  }

  renderAction(RowData, UserReducer) {
    const {isAdmin} = UserReducer.props
    let action = null
    let isOwner = UserReducer.username === RowData.Accessed.CreatedBy
     
    if(RowData.Status === 'incomplete') {
      if(RowData.Service.hasOwnProperty('IsQuickTest')) { 
        if(RowData.Service.IsQuickTest) {
          if(isAdmin || isOwner) {
            action = <button onClick={()=>this.props.onStartQuickTest(RowData.Alias)} className="btn btn-sm btn-primary">Quick Test</button>
          }else{
            action = <button className="btn btn-sm btn-default" disabled>Quick Test</button>
          }
        }else {
          if(isAdmin) {
            action = <button onClick={()=>this.props.onStartWork(RowData.Alias)} className="btn btn-sm btn-primary">Start Work</button>
          }else{
            action = <button className="btn btn-sm btn-default" disabled>Start Work</button>
          }
        }
      }
    } else if(RowData.Status === 'in-progress') {
      if(isAdmin) {
        action = <button onClick={()=>this.props.onFinishWork(RowData.Alias)} className="btn btn-sm btn-success">Finish Work</button>
      }else{
        action = <button className="btn btn-sm btn-default" disabled>Finish Work</button>
      }

    } else if(RowData.Status === 'completed') {
      action = <span className="badge badge-default" >Finished</span>

    } else {
      action = <span className="badge badge-default" >-</span>
    }

    return action
  }

  render() {
    const {RowData, UserReducer} = this.props;
    let repeating = null;

    if(RowData.IsRepeating === 'Yes') {
      repeating = RowData.RepeatPeriod+' '+RowData.RepeatType;
    } else {
      repeating = '-';
    }

    return (
      <tr>
        {ReactNativeWebView && ([
          <td className="text-center">{this.renderAction(RowData, UserReducer)}</td>,
          <td className="text-center">
            {this.renderLabel(RowData.Status)}
          </td>
        ])}
        <td>{RowData.Service.Name}</td>
        <td className="text-center">{moment(RowData.ScheduledStart).format('ll')}</td>
        <td className="text-center">{moment(RowData.ScheduledEnd).format('ll')}</td>
        <td className="text-center">{repeating}</td>
        <td className="text-center">{RowData.IsReminder}</td>
        <td className="text-center">{RowData.NextScheduled ? moment(RowData.NextScheduled).format('ll') : '-'}</td>
        {!ReactNativeWebView && ([
          <td key={RowData.Alias} className="text-center">{this.renderAction(RowData, UserReducer)}</td>,
          <td key={RowData.Alias+1} className="text-center">
            {this.renderLabel(RowData.Status)}
          </td>
        ])}
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/MaintenanceWorkList/MaintenanceWorkRow.js